import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private darkThemeClass = 'dark-theme';

  constructor() {
    const savedTheme = localStorage.getItem('theme');

    if (savedTheme === 'light' || savedTheme === 'dark') {
      this.setTheme(savedTheme as 'light' | 'dark');
    } else {
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      const systemTheme: 'light' | 'dark' = prefersDark ? 'dark' : 'light';
      this.setTheme(systemTheme);
    }
  }

  setTheme(theme: 'light' | 'dark') {
    const body = document.body;

    if (theme === 'dark') {
      body.classList.add(this.darkThemeClass);
    } else {
      body.classList.remove(this.darkThemeClass);
    }

    localStorage.setItem('theme', theme);
  }

  toggleTheme() {
    const isDark = document.body.classList.contains(this.darkThemeClass);
    this.setTheme(isDark ? 'light' : 'dark');
  }

  getCurrentTheme(): 'light' | 'dark' {
    return document.body.classList.contains(this.darkThemeClass) ? 'dark' : 'light';
  }
}
